import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "..";
import { GET_ADMIN_LEAVES, UPDATE_LEAVE_STATUS } from "../Queries/leaves";
import dayjs from "dayjs";
import { setLoader } from "./loaderSlice";

export const fetchAdminLeaves = createAsyncThunk(
    "leaves/fetchAdminLeaves", async ({ empid, fromDate, toDate, employeeId, loginUserId, role, department, leaveType, leaveStatus, userDepartment }, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setLoader(true))
            const response = await client.query({
                query: GET_ADMIN_LEAVES,
                variables: {
                    empid,
                    role,
                    department,
                    employeeId,
                    loginUserId,
                    leaveType,
                    leaveStatus,
                    fromDate,
                    toDate,
                    userDepartment
                },
                fetchPolicy: "network-only",
            })
            return response.data.getLeaveRequests;
        }
        catch (error) {
            return rejectWithValue(error.message || "Failed to fetch admin leaves");
        }
        finally {
            dispatch(setLoader(false))
        }
    })

export const updateAdminRequestAsync = createAsyncThunk(
    'leaves/adminleaves', async (leaveUpdates, { rejectWithValue }) => {
        try {
            const { data } = await client.mutate({
                mutation: UPDATE_LEAVE_STATUS,
                variables: {
                    leaveUpdates: leaveUpdates
                }
            })
            return data.updateLeaveStatus
        }
        catch (error) {
            console.error("failed to update leaves");
            return rejectWithValue(error.message || "failed to update leavs")
        }
    }
)
const initialState = {
    leaves: [],
    adminLeave: null,
    filters: {
        employeeName: "",
        selectedLeaveType: "",
        selectedLeaveStatus: "",
        selectedDepartment: "",
        selectedDate: null,
        selectedDateTwo: null,
    },
    isInitialFetched: false,
};

const adminLeaveRequest = createSlice({
    name: "leaves",
    initialState,
    reducers: {
        updateAdminRequest: (state, action) => {
            state.leaves = action.payload;
        },
        setFilters: (state, action) => {
            state.filters = {
                ...state.filters,
                ...action.payload,
            };
        },

        clearFilters: (state) => {
            state.filters = {
                employeeName: "",
                selectedLeaveType: "",
                selectedLeaveStatus: "",
                selectedDepartment: "",
                selectedDate: null,
                selectedDateTwo: null,
            };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAdminLeaves.fulfilled, (state, action) => {
                state.leaves = action.payload;
                state.isInitialFetched = true;
            })
            .addCase(updateAdminRequestAsync.fulfilled, (state, action) => {
                const updatedLeaves = action.payload;
                if (Array.isArray(updatedLeaves)) {
                    updatedLeaves.forEach((updatedLeave) => {
                        const index = state.leaves.findIndex((leave) => leave._id === updatedLeave._id);
                        if (index !== -1) {
                            state.leaves[index] = updatedLeave;
                        }
                    });
                }
            })
    }
});
export const { updateAdminRequest, setFilters, clearFilters } = adminLeaveRequest.actions;
export default adminLeaveRequest.reducer;